
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/stock/info",
      function () {
        return require("private-next-pages/ir/stock/info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/stock/info"])
      });
    }
  